import { lazy, type PropsWithChildren, Suspense } from "react"
import ThemeProvider from "@levana/ui/ThemeProvider"

import RootSetup from "@perps/root/RootSetup"
import NotificationLayout from "@future/notification/NotificationLayout"
import ChainContainer from "@future/chain/ChainContainer"
import SetupContext from "@future/context/SetupContext"

import QueryProvider from "./QueryProvider"

require("rujira.ui/src/scss/index.scss")

const RootLayout = (props: Parameters<typeof SetupContext>[0]) => {
  return (
    <SetupContext>
      {(contextStore) => (
        <ThemeProvider brandId="rujira">
          <RootSetup />
          <NotificationLayout />
          <QueryProvider>
            <ChainContainer>
              <RujiraProvider>{props.children?.(contextStore)}</RujiraProvider>
            </ChainContainer>
          </QueryProvider>
        </ThemeProvider>
      )}
    </SetupContext>
  )
}

const RujiraGlobalModalContext = lazy(() =>
  import("rujira.ui").then((ui) => ({ default: ui.GlobalModal })),
)

const TxButtonTip = lazy(() =>
  import("rujira.ui").then((ui) => ({ default: ui.TxButtonTip })),
)

const RujiraProvider = (props: PropsWithChildren) => {
  return (
    <Suspense>
      <RujiraGlobalModalContext>{props.children}</RujiraGlobalModalContext>
      <TxButtonTip />
    </Suspense>
  )
}

export default RootLayout
